import React from 'react'
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <>
     <footer className="new_footer_area">

      <div className="new_footer_top">

        <div className="hero-container">

          <div className="footer-grid">

            {/* COLUMN 1 */}

            <div className="footer-col">

              <h3>Get in Touch</h3>

              <p>
                Don’t miss any updates of our new courses,
                placements and training programs.
              </p>

              <form className="subscribe-form">

                <button
  className="btn btn-primary"
  onClick={() => window.location.href = "tel:9540155567"}
>
  📞 9540155567
</button>
              </form>

            </div>

            {/* COLUMN 2 */}

           {/* COLUMN 2 */}

<div className="footer-col">

  <h3>Manipal University Jaipur</h3>

  <ul>

    <li><Link to="/course/BCom">BCom</Link></li>
    <li><Link to="/course/BBA">BBA</Link></li>
    <li><Link to="/course/BCA">BCA</Link></li>
    <li><Link to="/course/MA">MA</Link></li>
    <li><Link to="/course/MSc">MSc</Link></li>
    <li><Link to="/course/MCom">MCom</Link></li>
    <li><Link to="/course/MBA">MBA</Link></li>
    <li><Link to="/course/MCA">MCA</Link></li>
    <li><Link to="/course/MAJMC">MAJMC</Link></li>

  </ul>

</div>

         {/* COLUMN 3 */}

<div className="footer-col">

  <h3>Sikkim Manipal University</h3>

  <ul>

    <li><Link to="/course/BA">BA</Link></li>
    <li><Link to="/course/BCom">BCom</Link></li>
    <li><Link to="/course/BBA">BBA</Link></li>
    <li><Link to="/course/MA">MA</Link></li>
    <li><Link to="/course/MCom">MCom</Link></li>
    <li><Link to="/course/MBA">MBA</Link></li>
    <li><Link to="/course/MCA">MCA</Link></li>

  </ul>

</div>

            {/* COLUMN 4 */}

            <div className="footer-col">

              <h3>Follow Us</h3>

              <div className="social-icons">

                <a target="_blank"href="https://www.facebook.com/share/1DzQhtEDpo/">
                  <i className="fab fa-facebook-f"></i>
                </a>

                <a target="_blank" href="https://www.instagram.com/broadways_training?igsh=eDRta3ZtemVhYnp0">
                  <i className="fab fa-instagram"></i>
                </a>

                

                

                <a
  href="https://wa.me/919540155567"
  target="_blank"
  rel="noreferrer"
>
  <i className="fab fa-whatsapp"></i>
</a>

              </div>

            </div>

          </div>

        </div>

        {/* ANIMATION */}

        <div className="footer_bg">

          <div className="footer_bg_one"></div>

          <div className="footer_bg_two"></div>

        </div>

      </div>

      {/* BOTTOM */}

      <div className="footer_bottom">

        <div className="container footer-bottom-flex">

          <p>
            © 2026 Broadways Training Services.
            All Rights Reserved.
          </p>

         

        </div>

      </div>

    </footer>

    </>
  )
}
